export function trackLinkedInConversion(conversionId) {
  if (!conversionId) return;
  if (typeof window.lintrk === "function") {
    window.lintrk("track", { conversion_id: conversionId });
  }
}